import { Navigate } from "@/components/navigation-controls/navigate";

import { TeamClimateActionListPage } from "./app/:teamId/climate-actions/all/team-climate-action-list.page";
import { TeamClimateActionListLayout } from "./app/:teamId/climate-actions/team-climate-action-list.layout";
import { TeamLayout } from "./app/:teamId/team.layout";
import { TeamPage } from "./app/:teamId/team.page";
import { TeamListLayout } from "./app/team-list.layout";
import { TeamListPage } from "./app/team-list.page";
import { TeamCreatePage } from "./settings/team-create.page";
import { TeamListSettingsLayout } from "./settings/team-list-settings.layout";
import { TeamListSettingsPage } from "./settings/team-list-settings.page";
import { TeamSettingsLayout } from "./settings/team-settings.layout";
import { TeamSettingsGeneralPage } from "./settings/team-settings-general.page";
import { TeamSettingsMembershipPage } from "./settings/team-settings-membership.page";

export const teamRoutes = [
  {
    path: "teams",
    element: <TeamListLayout />,
    children: [
      { path: "", element: <TeamListPage /> },
      {
        path: ":teamId",
        element: <TeamLayout />,
        children: [
          { path: "", element: <TeamPage /> },
          {
            path: "climate-actions",
            element: <TeamClimateActionListLayout />,
            children: [
              { path: "", element: <Navigate to="all" replace /> },
              { path: "all", element: <TeamClimateActionListPage /> },
            ],
          },
        ],
      },
    ],
  },
];

export const teamSettingsRoutes = [
  {
    path: "workspace/new-team",
    element: <TeamCreatePage />,
  },
  {
    path: "teams",
    element: <TeamListSettingsLayout />,
    children: [
      { path: "", element: <TeamListSettingsPage /> },
      {
        path: ":teamId",
        element: <TeamSettingsLayout />,
        children: [
          { path: "", element: <Navigate to="general" replace /> },
          { path: "general", element: <TeamSettingsGeneralPage /> },
          { path: "members", element: <TeamSettingsMembershipPage /> },
        ],
      },
    ],
  },
];
